import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { Cancel as RejectedIcon } from '@mui/icons-material';

export const ErrorState: React.FC = () => {
  return (
    <Box sx={{ 
      textAlign: 'center', 
      py: 12
    }}>
      <Paper sx={{ 
        p: 4, 
        background: 'linear-gradient(145deg, #fef2f2 0%, #fee2e2 100%)',
        border: '1px solid #fca5a5',
        borderRadius: 3,
        maxWidth: 500,
        mx: 'auto',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: 'linear-gradient(90deg, #ef4444 0%, #f87171 100%)'
        }
      }}>
        <Avatar sx={{ 
          width: 56, 
          height: 56, 
          backgroundColor: '#fecaca',
          color: '#dc2626',
          mx: 'auto',
          mb: 2
        }}>
          <RejectedIcon sx={{ fontSize: 28 }} />
        </Avatar>
        <Typography variant="h6" sx={{ color: '#dc2626', mb: 2, fontWeight: 700 }}>
          Unable to Load Dashboard
        </Typography>
        <Typography variant="body1" sx={{ color: '#7f1d1d', lineHeight: 1.6 }}>
          There was an issue retrieving refund data from the system. 
          Please check your connection and try again, or contact IT support if the problem continues.
        </Typography>
      </Paper>
    </Box>
  );
};